export default __webpack_public_path__ + "static/media/install-chat-widget2.d9545bc2.JPG";